const cidPermissions = (action, permissions, institutionId, year) => {
  if (
    action === 'cid:viewPage' &&
    permissions[institutionId].includes(`COUNTRY_INSIGHTS_DASHBOARD_${year}`)
  ) {
    return true;
  }

  return false;
};

module.exports = {
  cidPermissions,
};
